<div class="rota-detalhes-documentos-container">
  <div class="titulo">
    <div>
      <span class="mat-h3 bold">{{'ROUTE_REPORT.RECEIPTS.ADVANCE' | translate}}: </span>
      <span class="mat-h2"> {{adiantamento$ | async |  currency}}</span>
    </div>
    <div>
      <span class="mat-h3 bold">{{'ROUTE_REPORT.RECEIPTS.EXPENSES' | translate}}: </span>
      <span class="mat-h2"> {{despesas$ | async |  currency}}</span>
    </div>
  </div>
  <div class="flex flex-wrap ov-auto jc-space-evenly" *ngIf="((recibos$ | async)?.length || !((loaded$ | async) ?? 0)) else ElseContainer">
    <mat-card *ngFor="let referencia of (loaded$ | async) ? (recibos$ | async) : []" class="card mat-elevation-z1">
      <div class="card-header">
        <span class="card-text">
          {{referencia?.descricaoRecibo || referencia?.tipoRecibo}}
        </span>
        <span class="card-text pedido-ordem">{{(referencia.valor | currency) ?? '-'}}</span>
      </div>

      <div class="card-content">
        <ng-container *ngIf="(referencia.name?.split('\.')?.pop() || '').toLowerCase() !== 'pdf' else ElsePDF">
          <img [src]="referencia.linkView" alt="{{ 'ROUTE_REPORT.DOCUMENTS.RECEIPT' | translate }}"
            onerror="this.src = assetUrl('images/no_image.png')" mat-card-image>
        </ng-container>
        <ng-template #ElsePDF>
          <mat-icon class="icon-caminhao">picture_as_pdf</mat-icon>
        </ng-template>
      </div>

      <div class="card-actions">
        <div class="actions-container">
          <span class="card-text">{{referencia.data | date:'dd/MM/yy - HH:mm'}}</span>
          <span style="display: flex;">
            <a mat-button [disableRipple]="true" [href]="referencia.linkView" target="_blank"
               class="download-button">
              <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
            </a>
            <a mat-button [disableRipple]="true" [href]="referencia.linkDownload" target="_blank"
               class="download-button">
              <mat-icon fontSet="material-icons-outlined">file_download</mat-icon>
            </a>
          </span>
        </div>
      </div>
    </mat-card>

    <ngx-skeleton-loader class="flex fill flex-wrap ov-auto jc-space-evenly" count="5" appearance="circle" *ngIf="!((loaded$ | async) ?? 0)"></ngx-skeleton-loader>
  </div>

  <ng-template #ElseContainer>
    <div class="else-container">
      <mat-icon class="icon-caminhao">find_in_page</mat-icon>
      <span class="mat-body-2">{{ 'ROUTE_REPORT.DOCUMENTS.EMPTY_LIST' | translate }}</span>
    </div>
  </ng-template>
</div>
